module.exports = __webpack_public_path__ + "static/media/1-4.6bb82a86.svg";